import React, { useEffect, useState } from "react";
// javascript plugin used to create scrollbars on windows
import { Route, Routes } from "react-router-dom";

import routes from "../routes.js";
import { Container } from "reactstrap";
import Navigation from "../components/Navbars/Navigation.jsx";


export default function Auth() {
  return (
    <div className="content-login">
      <div className="img-bg"></div>
      <Navigation logoGestao={true}/>
      <Container className="margin-auth">
        <Routes>
          {routes.map((prop, key) => {
            const Screen = prop.component;
            if (prop.layout !== '/auth') {
              return "";
            }
            return (
              <Route
                path={prop.path}
                element={<Screen />}
                key={key}
              />
            );
          })}
        </Routes>
      </Container >
    </div >

  )

}